import { useParams } from 'react-router-dom';
import { RequestsV2UI } from './RequestsV2';
import { useUserContext } from '../../contexts/UserContext';
import { useEffect, useState } from 'react';
import { useStaticPermissions } from '../../hooks/usePermissions';
import { PERMISSION } from '../../constants/permissionConstants';
import { CURRENT_USER } from '../../constants/projectConstants';
import { getLocalStorage } from '../../helpers/jsHelper';
import NotFound from '../NotFound';
import Loader from '../../components/Loader/Loader';

let timeout = null;

function RequestsV2Edit() {
  const params = useParams();
  const { isUpdatingUserDetails } = useUserContext();
  const [hasProductPageRequestPermission, setHasProductPageRequestPermission] = useState(false);
  const { hasPermission } = useStaticPermissions();
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    checkPermission();
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [isUpdatingUserDetails]);

  const checkPermission = () => {
    if (timeout) clearTimeout(timeout);
    if (isUpdatingUserDetails) {
      setLoader(true);
      return;
    }
    let currentUser = getLocalStorage(CURRENT_USER);
    currentUser = currentUser ? JSON.parse(currentUser) : {};
    const permissionsMap = currentUser?.permissions_list?.reduce((acc, p) => {
      acc[p.codename] = p;
      return acc;
    }, {});
    const _hasProductPageRequestPermission = hasPermission(
      PERMISSION.CAN_CREATE_PRODUCT_PAGE_REQUEST,
      permissionsMap
    );
    setHasProductPageRequestPermission(_hasProductPageRequestPermission);
    // this is needed due to flickering of page
    timeout = setTimeout(() => setLoader(false), 1000);
  };

  if (isUpdatingUserDetails || loader)
    return (
      <Loader
        loading={true}
        position="absolute"
        style={{
          backgroundColor: '#F6F6F6',
        }}
      />
    );

  if (!hasProductPageRequestPermission) {
    return (
      <NotFound
        hidePageTitle={true}
        hideButton={true}
        message="You don't have any request assigned"
        className="vh-100"
      />
    );
  }

  return <RequestsV2UI openedRequestId={params.id} />;
}

export default RequestsV2Edit;
